import { render } from "./Empty.vue?vue&type=template&id=6cb0ebb4&scoped=true&ts=true"
import script from "./Empty.vue?vue&type=script&lang=ts"
export * from "./Empty.vue?vue&type=script&lang=ts"

import "./Empty.vue?vue&type=style&index=0&id=6cb0ebb4&scoped=true&lang=css"

import exportComponent from "D:\\Working\\Projects\\EcosystemPlus\\src\\Web\\Ecosystem.EInvoice.Web\\Themes\\EInvoice\\Mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb0ebb4"]])

export default __exports__